import { Ortak } from './../../../../providers/ortak';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the MarkaEklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-marka-ekle',
  templateUrl: 'marka-ekle.html',
})
export class MarkaEklePage {
  marka:any={ID:-1,MarkName:""};
  markaID:any={};
gidenmarkaadi="";
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("markaVw") != null) {
        this.markaID = navParams.get("markaVw");
        var data = new FormData();
        data.append("Marka_id", this.markaID.ID);
        this.bllOrtak.islem(data, "MarkaGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.marka = Sonuc.SonucObject;
         
        }
        )
      }
  }

  ionViewDidLoad() {
    
  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.marka.MarkName== null || this.marka.MarkName== "") {
      mesaj = mesaj + "Lütfen Marka adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      this.gidenmarkaadi=this.marka.MarkName;
      console.log("gidenmarka",this.gidenmarkaadi);
      formData.append("Marka_Adi",this.gidenmarkaadi);
      formData.append("Marka_json", JSON.stringify(this.marka));
     
      this.bllOrtak.islem(formData, "MarkaEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        console.log("sonuc",sonuc.Sonuc);
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
        if(sonuc.Sonuc==0) this.ortak.showBasicAlert("Hata",this.marka.MarkName+"   "+"   "+"adlı marka zaten mevcut");
       
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/MarkaIslemleri/marka-ekle/marka-ekle.ts